export default __webpack_public_path__ + "static/media/Rank3Q.cd350b13.png";